export * from './dlg-success-buy.component';
